import Logger from '../../../utils/Logger';
import AxiosHttpClient from '../../../utils/HttpClient';
export default class BillingUserInfoStatusManager {
    static async loadBillingUserInfoStatusForCurrentUser() {
        const requestUrl = `${BillingUserInfoStatusManager.ENDPOINT_BILLING_USER_INFO_STATUS}`;
        Logger.info(BillingUserInfoStatusManager.TAG, `Fetching Sub Accounts from ${requestUrl}...`);
        const client = new AxiosHttpClient();
        const data = await client.get(requestUrl);
        return data.billingUserInfoStatusSpec;
    }
}
BillingUserInfoStatusManager.TAG = 'BillingUserInfoStatusManager';
BillingUserInfoStatusManager.ENDPOINT_BILLING_USER_INFO_STATUS = '/billing/v1/billing_user_info_status';
//# sourceMappingURL=BillingUserInfoStatusManager.js.map